<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Daftar Kelas
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <!--<div class="row align-items-center">
            <div class="col-auto mb-4 ml-auto">
                <router-link v-bind:to="{ name: 'forum/recapitulation' }" class="btn btn-outline-danger btn-sm px-3">
                    Rekapitulasi Solved
                </router-link>
            </div>
        </div>-->

        <div class="row">
            <div class="col">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0 text-uppercase">
                                    Kelas
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body py-0">
                        <div class="row">
                            <div class="col-12 col-sm-6 border-bottom py-3" v-for="grade in grades">
                                <router-link v-bind:to="{ name: 'forum/subject', params: {id: grade.id} }" class="font-weight-bold h4 mb-1">{{ grade.name }}</router-link>
                                <div class="row text-muted">
                                    <div class="col-auto">
                                        Jumlah Pelajaran: {{ grade.totalSubjects }}
                                    </div>
                                    <div class="col-auto">
                                        Jumlah Thread: {{ grade.totalThreads }}
                                    </div>
                                    <div class="col-auto">
                                        Solved Thread: {{ grade.solvedThreads }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "ForumIndex",
        computed: mapState([
            'term'
        ]),
        watch: {
            term() {
                this.fetchData();
            }
        },
        data() {
            return {
                grades: []
            };
        },
        methods: {
            fetchData() {
                this.axios.get(process.env.API_URL + '/grade', {params: {termID: this.term.id}}).then(response => {
                    this.grades = response.data.data;
                });
            }
        },
        created() {
            this.fetchData();

            document.title = 'Forum - ' + process.env.APP_NAME;
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/Index.vue